<mat-card class="m-auto padding12 home-card boxshadowgrey">
    <div>
        <button mat-icon-button color="primary" class="back-button" routerLink="/machineState">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>
    <div class="content">
    <mat-card-title-group class="home-card" id="title">
        <mat-card-title>{{ 'MASCHINESTATE.GRAPH.MENUHEADER' | translate}}</mat-card-title>
        <mat-card-subtitle>{{ 'MASCHINESTATE.GRAPH.SUBMENUHEADER' | translate}}</mat-card-subtitle>
       
    </mat-card-title-group>

    <mat-card-content>
        <div class="home-card" id="content">
            <!--
                Spinner while config is loading
            -->
            <div class="loading-spinner-container" *ngIf="this.apiConnection.basicMachineFunctionsConfig.functions.length == 0">
                <mat-progress-spinner class="loading-spinner" mode="indeterminate" color="primary"></mat-progress-spinner>
            </div>

            <!--
                Menu if config is loaded
            -->
            <ng-container *ngIf="this.apiConnection.basicMachineFunctionsConfig.functions.length > 0">
                <div class="home-nav">
                    <div class="home-nav-menu" cdkMenu>
                        <ng-container *ngFor="let func of this.apiConnection.basicMachineFunctionsConfig.functions">
                            <button
                                mat-stroked-button
                                class="mat-item-button"
                                cdkMenuItem
                                color="primary"
                                (click)="clickBasicFunctionName(func.name)"
                            >
                                <mat-icon>legend_toggle</mat-icon>
                                <span class="menu-item-label">{{ func.name }}</span>
                            </button>
                        </ng-container>
                    </div>
                </div></ng-container
            >
        </div>
    </mat-card-content>
    </div>
</mat-card>
